import React from 'react';

import { Box, Flex, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import RabbitGoalProgressBar from 'screens/Team/Rabbit/Goals/Audit/RabbitGoalProgressBar';

import { ErrorOutline } from 'assets/assetsV1/iconComponents';

import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const Container = styled(Flex)`
  padding: 0px;
  &:hover {
    & .highlightTextOnHover {
      color: #1565bc;
    }
  }
  cursor: pointer;
`;

export const KRNameAndProgressCell = ({
  hasError = false,
  errorMessage = '',
  data,
  w = '242px',
  containerProps = {},
}) => {
  const theme = useTheme();
  const {
    progressLevel: goalProgressLevel,
    achieved,
    target,
    startValue = 0,
    title: goalName,
    avgProgressPercentage,
    closureStatus: goalClosureStatus,
  } = data;

  return (
    <Container ml={1.5} {...containerProps}>
      <Flex width="100%">
        <Flex flexDir="column" width="100%">
          <TextBodyMedium className="highlightTextOnHover">
            {hasError ? (
              <Tooltip label={errorMessage} fontSize="14px">
                <Box as="span" lineHeight="20px">
                  <ErrorOutline
                    style={{ marginRight: '8px', marginBottom: '2px' }}
                    boxSize="16px"
                    color={theme.colors.alerts.negative}
                  />
                </Box>
              </Tooltip>
            ) : null}
            {goalName}
          </TextBodyMedium>
          <Flex mt={2} alignItems="center">
            <Flex
              flexDir="column"
              w={w}
              sx={{
                '& p': {
                  minWidth: '7ch',
                },
              }}
            >
              <RabbitGoalProgressBar
                goalProgressLevel={goalProgressLevel}
                percentageValue={avgProgressPercentage?.toFixed(2)}
                goalClosureStatus={goalClosureStatus}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};
